/** Pull a human-readable message out of an RTK Query error. */
export function errorDetail(err: unknown, fallback = 'Something went wrong.'): string {
  if (err && typeof err === 'object' && 'data' in err) {
    const data = (err as { data?: unknown }).data;
    if (data && typeof data === 'object' && 'detail' in data) {
      return String((data as { detail: unknown }).detail);
    }
  }
  return fallback;
}
